module.exports = __webpack_public_path__ + "media/images/flags/ad-66c8304a1ea873e2508c83386debe068.svg";